import http from "../../http";

export default {
  file: (data) => {
    return http.post("opservice/ophonoredguest/savefile", data);
  },
  base64: (data) => {
    let base64Params = {
      prefix: "base64image",
      suffix: ".png",
      base64: data.replace("data:image/png;base64,", ""),
    };
    return http.post("opservice/ophonoredguest/base64/savefileinfo", base64Params);
  },
  remoteUrl: (data) => {
    let remoteUploadApiUrl = "content-service/cnt_article/xm/reptile";
    let dataParams = [
      {
        "source[]": data,
      },
    ];
    dataParams.forEach((item, index) => {
      remoteUploadApiUrl +=
        (index == 0 ? "?" : "&") + "source[]=" + item["source[]"];
    });
    return http.post(remoteUploadApiUrl, dataParams);
  },
};
